// @ts-nocheck

import { SpineAnimationIds } from '../../../types/animations';
import { GRRounds } from '../types/round';

export const GRRoundViewByOrder = [GRRounds.SHOE, GRRounds.BALLOON, GRRounds.SHIRT];

export const GRRoundIndexByRoundId = {
  [GRRounds.SHOE]: GRRoundViewByOrder.indexOf(GRRounds.SHOE),
  [GRRounds.BALLOON]: GRRoundViewByOrder.indexOf(GRRounds.BALLOON),
  [GRRounds.SHIRT]: GRRoundViewByOrder.indexOf(GRRounds.SHIRT),
};

export const GRSpineAnimationIdByRoundId = {
  [GRRounds.SHOE]: SpineAnimationIds.GR_SHOE,
  [GRRounds.BALLOON]: SpineAnimationIds.GR_BALLOON,
  [GRRounds.SHIRT]: SpineAnimationIds.GR_SHIRT,
};
